<div class="image-container" [ngClass]="cssClass" id="button{{ randomId }}">
  <img [src]="image" class="cell-image" />
</div>

<div id="tooltip{{ randomId }}">
  <img [src]="image" class="enlarged-image" />
</div>
